export default ({ user, permissions }) => {
  if (!user) {
    return false;
  }

  if (permissions && permissions.length) {
    return user.permissions &&
      user.permissions.some(x => x === 'admin' || permissions.includes(x));
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/authorized.js